import type { ThemeConfig } from "antd";

// Modern 2025 palette:
//   Primary  — Indigo 500 (#6366f1)  popular in SaaS/monitoring tools
//   Sidebar  — Slate 950 (#0f172a)   deep dark nav
//   Content  — Slate 50  (#f8fafc)   airy background
//   Cards    — White + subtle shadow

export const wansightTheme: ThemeConfig = {
  token: {
    colorPrimary:   "#6366f1",
    colorInfo:      "#6366f1",
    colorLink:      "#818cf8",
    colorSuccess:   "#10b981",
    colorWarning:   "#f59e0b",
    colorError:     "#ef4444",

    borderRadius:   8,
    borderRadiusLG: 10,
    borderRadiusSM: 6,
    borderRadiusXS: 4,

    colorBorder:          "#e2e8f0",
    colorBorderSecondary: "#f1f5f9",
    colorBgLayout:        "#f8fafc",
    colorBgContainer:     "#ffffff",
    colorText:            "#334155",
    colorTextSecondary:   "#64748b",
    colorTextHeading:     "#0f172a",

    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Inter", "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    fontSize:         13,
    fontSizeHeading3: 18,
    fontSizeHeading4: 15,
    fontSizeHeading5: 14,
    lineHeight:       1.5,
    controlHeight:    32,
    controlHeightSM:  26,
  },
  components: {
    Layout: {
      headerBg:      "#0f172a",
      headerHeight:  48,
      headerPadding: "0 20px",
      siderBg:       "#0f172a",
      bodyBg:        "#f8fafc",
      footerBg:      "#f1f5f9",
      footerPadding: "10px 24px",
    },
    Menu: {
      itemBg:          "transparent",
      itemColor:       "#94a3b8",
      itemSelectedBg:  "rgba(99,102,241,0.15)",
      itemSelectedColor: "#a5b4fc",
      itemHoverBg:     "rgba(255,255,255,0.06)",
      itemHoverColor:  "#e2e8f0",
      itemHeight:      36,
      iconSize:        14,
      groupTitleColor:    "#475569",
      groupTitleFontSize: 10,
    },
    Card: {
      headerBg:       "#fafafa",
      headerHeight:   40,
      headerFontSize: 13,
      paddingLG:      16,
    },
    Table: {
      headerBg:            "#f8fafc",
      headerColor:         "#64748b",
      headerSplitColor:    "#e2e8f0",
      borderColor:         "#f1f5f9",
      rowHoverBg:          "#f5f3ff",
      cellPaddingBlock:    8,
      cellPaddingInline:   12,
      cellPaddingBlockSM:  5,
      cellPaddingInlineSM: 8,
      cellFontSize:        13,
    },
    Button: {
      controlHeight:   32,
      controlHeightSM: 26,
      fontSize:        13,
      paddingInline:   14,
      fontWeight:      500,
    },
    Input: {
      controlHeight: 32,
      paddingInline:  10,
    },
    Select: {
      controlHeight: 32,
    },
    Modal: {
      headerBg:      "#ffffff",
      titleFontSize: 14,
      titleColor:    "#0f172a",
      contentBg:     "#ffffff",
    },
    Form: {
      itemMarginBottom:     16,
      labelFontSize:        13,
      verticalLabelPadding: "0 0 4px",
    },
    Tabs: {
      titleFontSize:        13,
      horizontalItemPadding: "8px 16px",
    },
    Tag: {
      defaultBg:    "#f1f5f9",
      defaultColor: "#475569",
      borderRadiusSM: 4,
    },
    Statistic: {
      titleFontSize:   12,
      contentFontSize: 26,
    },
    Badge: {
      statusSize: 7,
    },
  },
};
